<template>
    <div class="alert-modal" :class="{'toggle-alert': isActive}">
        <div class="alert-modal-container">
            <div class="modal-content">
                <div class="">
                    <div id="alert-modal" class="card bg-orange-gradLight">
                        <button class="btn-close" @click="closeModal">
                            <img :src="iconClose" alt="close">
                        </button>

                        <div class="card-body">
                            <slot></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import icClose from '../../svg/ic_close_orange.svg'

export default {
    data() {
        return {
            iconClose: icClose,
            isActive:true
        }
    },
    mounted(){
        this.toggleOverflow();
    },
    methods: {
        toggleOverflow(){
            document.querySelector('html').classList.toggle('no-scroll');
            document.querySelector('body').classList.toggle('no-scroll');
        },
        closeModal() {
            this.isActive = !this.isActive;
            this.toggleOverflow();
        }
    }
}
</script>
